<script lang="ts" setup>
import { onErrorCaptured, ref } from 'vue';
import { useTranslationUtils } from '#layers/i18n';

defineProps<{
	name?: string;
	icon?: string;
}>();

const error = ref<any>(null);

const { translateString } = useTranslationUtils();

onErrorCaptured((err) => {
	console.error('BlockRender error:', err);
	error.value = err;
	return false;
});

function retry() {
	error.value = null;
}
</script>

<template>
	<!-- TODO refactor this using the `ErrorAlert` component from `studio` -->
	<DAlert
		v-if="error"
		color="error"
		:title="$t('block_render.error', { block: translateString(name) })"
		:description="error.message"
		:actions="[
			{
				label: $t('block_render.retry'),
				color: 'error',
				onClick: retry,
			},
		]"
	/>
	<slot v-else />
</template>
